import { $gryffBody } from '@/app/index';

export const showHeaderFooter = (isShow: boolean) => {
  const _$gryffBody = $gryffBody();
  const $headerFooterSection = _$gryffBody.find('[data-section-id="header"], [data-section-id="footer"]');

  if (isShow) {
    $headerFooterSection.show();
  } else {
    $headerFooterSection.hide();
  }
};
